export const homePath = '/';
export const aboutUsPath = '/about-us';
export const servicePath = '/services';
export const caseStudyPath = '/case-study';
export const mainBlogPath = '/blog';
export const contactPath = '/contact';
